import SystemSettingApi from '@api/system_settings.api';

const state = {
    settings: {
        system_name_ar: '',
        system_name_en: '',
        system_logo: '',
        system_logo_url: '',
        system_favicon: '',
        system_favicon_url: '',
        system_login_logo_url: '',
        system_sidebar_logo_url: '',
        system_currency: 'KWD'
    }
};

const getters = {
    systemSettings: state => state.settings,
    systemLogo: state => state.settings.system_logo_url,
    systemFavicon: state => state.settings.system_favicon_url,
    systemCurrency: state => state.settings.system_currency || 'KWD',

    // New specific logo getters with fallback to main system logo
    loginLogo: state => state.settings.system_login_logo_url || state.settings.system_logo_url,
    sidebarLogo: state => state.settings.system_sidebar_logo_url || state.settings.system_logo_url,

    systemName: (state, getters, rootState, rootGetters) => {
        const locale = localStorage.getItem('locale') || 'ar';
        return locale.startsWith('ar') ? state.settings.system_name_ar : state.settings.system_name_en;
    }
};

const mutations = {
    SET_SETTINGS(state, settings) {
        state.settings = { ...state.settings, ...settings };

        // Apply favicon to DOM
        if (settings.system_favicon_url) {
            let link = document.querySelector("link[rel~='icon']");
            if (!link) {
                link = document.createElement('link');
                link.rel = 'icon';
                document.getElementsByTagName('head')[0].appendChild(link);
            }
            link.href = settings.system_favicon_url;
        }

        // Apply Global Colors
        if (settings.primary_color) {
            document.documentElement.style.setProperty('--primary-color', settings.primary_color);
        }
        if (settings.secondary_color) {
            document.documentElement.style.setProperty('--secondary-color', settings.secondary_color);
        }
    }
};

const actions = {
    fetchSettings({ commit }) {
        return SystemSettingApi.getSettings().then(response => {
            if (response && response.data && response.data.settings) {
                commit('SET_SETTINGS', response.data.settings);
                return response.data.settings;
            }
            return null;
        }).catch(error => {
            console.error('Failed to fetch settings:', error);
            return null;
        });
    },
    updateSettings({ commit }, settings) {
        commit('SET_SETTINGS', settings);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
